import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserResponse } from 'api/types';
import { userAPI } from 'api/user';
import { closeLoginModal } from 'features/ui/ui-slice';
import { AppThunk, RootState } from 'redux/store';
import { User } from './types';

const initialState: User = {
  id: null,
  login: null,
  email: null,
  name: 'Гость',
  lastName: null,
  type: 'guest',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<UserResponse>) => {
      state.id = payload.id;
      state.login = payload.login;
      state.email = payload.email;
      state.name = payload.name;
      state.lastName = payload.lastName;
      state.type = payload.type;
    },
  },
});

export const authorizeUser = (): AppThunk => async (dispatch) => {
  try {
    const user = await userAPI.authorize();
    dispatch(setUser(user));
  } catch (error) {}
};

export const loginUser = (login: string, password: string): AppThunk => async (
  dispatch
) => {
  try {
    const user = await userAPI.login(login, password);
    dispatch(setUser(user));
  } catch (error) {
  } finally {
    dispatch(closeLoginModal());
  }
};

export const logoutUser = (): AppThunk => async (dispatch) => {
  try {
    const user = await userAPI.logout();
    dispatch(setUser(user));
  } catch (error) {}
};

export const { setUser } = userSlice.actions;

export const selectUser = (state: RootState) => state.user;

export const userReducer = userSlice.reducer;
